import { flattenCoordinates, type Coordinates } from "$lib/features/_other/coordinates.type";
import { Map as LibreMap, LngLatBounds } from "maplibre-gl";

export function getBounds(coords: Coordinates[]): LngLatBounds {
    const bounds = new LngLatBounds();
    if (coords.length === 0) return bounds;
    coords.forEach((coord) => bounds.extend(flattenCoordinates(coord)));
    return bounds;
}

export function getMaxBounds(bounds: LngLatBounds, leanWay = 0.5): LngLatBounds {
    return new LngLatBounds(
        [bounds.getWest() - leanWay, bounds.getSouth() - leanWay],
        [bounds.getEast() + leanWay, bounds.getNorth() + leanWay]
    );
}

export function assignMissingStyleImageResolver(map: LibreMap): void {
    map.setMissingStyleImageResolver((id) => {
        if (!map.hasImage(id)) {
            map.addImage(id, {
                width: 1,
                height: 1,
                data: new Uint8Array(4)
            });
        }
    });
}